module.exports = __webpack_public_path__ + "static/img/home_bg.b932af88.jpg";